<div class="estimated-amt-div paragraph-large-regular">
  <p>Estimated total amount: SGD {{ estTotalAmt }}</p>
</div>
<div class="button-container container-fluid" *ngIf="permissionData$| async as permissionData">
  <app-button class="test" icon="add" name="Add item" type="flat-button" tabindex="0"
    (keypress)="childDocument || (!isReadOnly || permissionData.ability.can('add', permissionData.formAor)) && !isReferenced && navigateToAddItem(0)"
    (click)="childDocument ||  (!isReadOnly || permissionData.ability.can('add', permissionData.formAor)) && !isReferenced && navigateToAddItem(0)"
    [disabled]="childDocument || (isReadOnly && !permissionData.ability.can('add', permissionData.formAor)) || isReferenced"></app-button>

    <app-button class="test" icon="download" name="Download template" type="basic" tabindex="0"
    (keypress)="(!isReadOnly || permissionData.ability.can('add', permissionData.formAor)) && downlaodtemplate()"
    (click)="(!isReadOnly || permissionData.ability.can('add', permissionData.formAor)) && downlaodtemplate()"
    [disabled]="(isReadOnly && !permissionData.ability.can('add', permissionData.formAor))"></app-button>

    <app-button class="test" icon="upload" name="Upload template" type="basic" tabindex="0"
      (keypress)="childDocument || (!isReadOnly || permissionData.ability.can('add', permissionData.formAor)) && uploadTemplate()"
      (click)="childDocument || (!isReadOnly || permissionData.ability.can('add', permissionData.formAor)) && uploadTemplate()"
      [disabled]="childDocument || (isReadOnly && !permissionData.ability.can('add', permissionData.formAor))"></app-button>

  <!-- <app-button
    class="test"
    icon="content_copy"
    name="Item reference"
    type="flat-button"
    (click)="itemReferenceOnClickHandler()"
    [disabled]="isReadOnly"
  ></app-button> -->
  <!-- <app-button
    class="test"
    icon="edit"
    name="Batch edit"
    type="flat-button"
    [disabled]="true"
  ></app-button> -->
  <!-- <app-button
    class="test"
    icon="download"
    name="Download template"
    type="flat-button"
    [disabled]="isReadOnly"
  ></app-button> -->
  <!-- <app-button
    class="test"
    icon="upload"
    name="Upload"
    type="flat-button"
    [disabled]="isReadOnly"
  ></app-button> -->
  <!-- <app-button
    class="test"
    icon="settings"
    name="Settings"
    type="flat-button"
  ></app-button> -->
</div>
<div *ngIf="permissionData$| async as permissionData">

  <app-add-reference-card
    *ngIf="dataSource.data.length < 1 && (!isReadOnly || permissionData.ability.can('add', permissionData.formAor))"
    desc="You have not added any item." btnLabel="+ Add item" tabindex="0" (keypress)="navigateToAddItem(0)"
    (click)="navigateToAddItem(0)"></app-add-reference-card>
</div>

<div class="item-table-container myPurchase-table-container" [hidden]="dataSource.data.length == 0"
  *ngIf="permissionData$| async as permissionData" (scroll)="onTableScroll($event)">
  <!-- <div class="mat-table-wrapper"> -->
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 data-grid-table">
    <!-- Checkbox Column -->
    <!-- <ng-container matColumnDef="select">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
        >
        </mat-checkbox>
      </mat-cell>
    </ng-container> -->
    <ng-container *ngFor="let column of columns; let i = index">
      <!-- first column -->
      <ng-container [matColumnDef]="column.columnDef" *ngIf="i == 0" sticky>
        <th mat-header-cell *matHeaderCellDef>
          {{ column.header }}
        </th>
        <td mat-cell *matCellDef="let row">
          <ng-container class="item-row-hover"
            *ngIf="row.hovered && (!row.isDeleted && !row.Strikethrough && !isReferenced && (!isReadOnly || permissionData.ability.can('update', permissionData.formAor))) && !childDocument">
            <!-- <a (click)="navigateToAddItem(row)">
              <div class="row-button">
                <mat-icon title="Edit">edit</mat-icon>
              </div>
            </a> -->
            <!--if you have update permissions and is read only is true, then dont show this-->
            <!-- <div>
              <a (click)="openDialog(row)"
                *ngIf="!isReadOnly || permissionData.ability.can('delete', permissionData.formAor)">
                <div class="row-button">
                  <mat-icon title="Discard">delete</mat-icon>
                </div>
              </a>
              <a (click)="openCopyDialog(row)"
                *ngIf="!isReadOnly || permissionData.ability.can('copy', permissionData.formAor)">
                <div class="row-button">
                  <mat-icon title="content_copy">content_copy</mat-icon>
                </div>
              </a>
            </div> -->
          </ng-container>
          <!-- <ng-container class="item-row-hover"
            *ngIf="row.hovered && (( (!row.isDeleted && !row.Strikethrough) || isDocComplete) && (isReadOnly && permissionData.ability.cannot('update', permissionData.formAor)  || isReferenced ) || childDocument)">
            <a (click)="navigateToAddItem(row)">
              <div class="row-button">
                <mat-icon title="visibility">visibility</mat-icon>
              </div>
            </a>
            
            <a (click)="openDialog(row)"
              *ngIf="docSubStatus==47 || docSubStatus==52  && (RO == loggedInUser.userName || createdBy==loggedInUser.userName)">
              <div class="row-button">
                <mat-icon title="Discard">delete</mat-icon>
              </div>
            </a>
          </ng-container> -->
          <div class="item-row-no">
            {{column.cell(row)}}
          </div>
        </td>
      </ng-container>
      <!-- second column to freeze -->
      <ng-container [matColumnDef]="column.columnDef" *ngIf="i == 1" sticky>
        <th mat-header-cell *matHeaderCellDef>
          {{ column.header }}
        </th>
        <td mat-cell *matCellDef="let row" [ngClass]="{ 'deleted-row': row.isDeleted || row.Strikethrough}">
          {{ column.cell(row) }}
        </td>
      </ng-container>
      <ng-container [matColumnDef]="column.columnDef" *ngIf="i == 2" sticky>
        <th mat-header-cell *matHeaderCellDef>
          {{ column.header }}
        </th>
        <td mat-cell *matCellDef="let row" [ngClass]="{ 'deleted-row': row.isDeleted || row.Strikethrough }">
          {{ column.cell(row) }}
        </td>
      </ng-container>

      <ng-container [matColumnDef]="column.columnDef" *ngIf="i > 2 && column.columnDef !== 'Actions'">
        <th mat-header-cell *matHeaderCellDef>
          {{ column.header }}
        </th>
        <!-- column with tp -->
        <ng-container *ngIf="column.columnDef === 'ItemDescription'">
          <td mat-cell *matCellDef="let row" [ngClass]="{ 'deleted-row': row.isDeleted || row.Strikethrough }" 
            [tp]="column.cell(row)" tpClassName="custom-tooltip" tpMaxWidth="300px" [tpInteractive]="true" 
            [tpIsEnabled]="column.cell(row).length > 64"
            tpPlacement="bottom">
            {{ column.cell(row) }}
          </td>
        </ng-container>
        <!-- column without tp -->
        <ng-container *ngIf="column.columnDef !== 'ItemDescription'">
          <td mat-cell *matCellDef="let row" [ngClass]="{ 'deleted-row': row.isDeleted || row.Strikethrough }">
            {{ column.cell(row) }}
          </td>
        </ng-container>
      </ng-container>

      <ng-container [matColumnDef]="column.columnDef" *ngIf="column.columnDef === 'Actions'" stickyEnd>
        <th mat-header-cell *matHeaderCellDef>
          {{ column.header }}
        </th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button aria-label="Edit" title="Edit" (click)="navigateToAddItem(row, $event)" 
            [disabled]="getUpdateActionState(row, permissionData.ability.can('update', permissionData.formAor))">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button aria-label="Copy" title="Copy" (click)="openCopyDialog(row, $event)"
            [disabled]="getUpdateActionState(row, permissionData.ability.can('update', permissionData.formAor), permissionData.ability.can('copy', permissionData.formAor))">
            <mat-icon>content_copy</mat-icon>
          </button>
          <ng-container *ngIf="!isReadOnly || permissionData.ability.can('update', permissionData.formAor)">
            <button mat-icon-button aria-label="Delete" (click)="openDialog(row, $event)" title="Delete"
              [disabled]="getUpdateActionState(row, permissionData.ability.can('update', permissionData.formAor), permissionData.ability.can('delete', permissionData.formAor))">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-container>
          <ng-container *ngIf="!(!isReadOnly || permissionData.ability.can('update', permissionData.formAor))">
            <button mat-icon-button aria-label="Delete" (click)="openDialog(row, $event)" title="Delete"
              [disabled]="!getViewActionState('delete', row, permissionData.ability.cannot('update', permissionData.formAor))">
              <mat-icon>delete</mat-icon>
            </button>
          </ng-container>
          <!-- <button mat-icon-button aria-label="Show more">
            <mat-icon>more_vert</mat-icon>
          </button> -->
        </td>
      </ng-container>
      <!-- <ng-container *ngIf="i === 1" [matColumnDef]="'frozenColumn'">
                    <td mat-cell *matCellDef="let row">{{ column.cell(row) }}</td>
                  </ng-container> -->
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (mouseenter)="row.hovered = true" class="element-row"
      [class.clickable]="getViewActionState('view', row, permissionData.ability.cannot('update', permissionData.formAor))"
      (mouseleave)="row.hovered = false" (click)="getViewActionState('view', row, permissionData.ability.cannot('update', permissionData.formAor)) ? navigateToAddItem(row, $event) : null"></tr>
  </table>
</div>
<mat-paginator *ngIf="dataSource.data.length > 0" #itemPg [length]="dataSource.data.length" [pageSize]="20"  [pageSizeOptions]="pageSizeOptions"
  showFirstLastButtons></mat-paginator>
<div *ngIf="permissionData$| async as permissionData">
  <app-tender-item *ngIf="purchaseType === 'tender' || purchaseType === 'dc'"
    [isReadOnly]="isReadOnly && !permissionData.ability.can('update',permissionData.formSow)"></app-tender-item>
</div>